const context = 'app'

export const TOGGLE_APP_STATE = `${context}/TOGGLE_APP_STATE`

export const SIGN_IN = `${context}/SIGN_IN`
